import React from 'react'

const GrantSummaryCardShimmerEffect = () => {
  return (
  <div className="govdash-summaryGrid">
  {/* Shimmer: Total Voters */}
  {/* Shimmer: Total Amount Disbursed */}
  <div className="govdash-summaryCard govdash-amountCard">
    <div className="govdash-cardContent">
      <i className="fas fa-money-bill-wave" style={{ opacity: 0.3 }}></i>
      <div>
        <p className="govdash-cardLabel">
          <span className="shimmer" style={{ width: '140px', height: '14px', display: 'inline-block' }}></span>
        </p>
        <span className="govdash-cardValue">
          <span className="shimmer" style={{ width: '120px', height: '32px', display: 'block' }}></span>
        </span>
      </div>
    </div>
    <div className="govdash-cardBg"></div>
  </div>

  {/* Shimmer: Total Labharti */}
  <div className="govdash-summaryCard govdash-labhartiCard">
    <div className="govdash-cardContent">
      <i className="fas fa-hand-holding-heart" style={{ opacity: 0.3 }}></i>
      <div>
        <p className="govdash-cardLabel">
          <span className="shimmer" style={{ width: '90px', height: '14px', display: 'inline-block' }}></span>
        </p>
        <span className="govdash-cardValue">
          <span className="shimmer" style={{ width: '110px', height: '32px', display: 'block' }}></span>
        </span>
      </div>
    </div>
    <div className="govdash-cardBg"></div>
  </div>
</div>
  )
}

export default GrantSummaryCardShimmerEffect
